import format from "date-fns/format";
import { zhCN } from "date-fns/locale";

const defaultOptions = {
  locale: zhCN
};

const FMT_DATE = "yyyy年MM月dd日";
const FMT_TIME = "HH:mm:ss";
const FMT_DATETIME = `${FMT_DATE} ${FMT_TIME}`;
const FMT_PARAM_DATETIME = "yyyy-MM-dd HH:mm:ss";
const FMT_PARAM_DATE = "yyyy-MM-dd";
const FMT_PARAM_TIME = "HH:mm";

/**
 * 将日期时间格式化为后端接口参数所需要的格式
 * @param d
 * @returns {string | *}
 */
export const timeParam = d => format(d, FMT_PARAM_TIME);

/**
 * 将日期时间格式化为后端接口参数所需要的格式
 * @param d
 * @returns {string | *}
 */
export const dateParam = d => format(d, FMT_PARAM_DATE);

/**
 * 将日期时间格式化为后端接口参数所需要的格式
 * @param d
 * @returns {string | *}
 */
export const datetime4Param = d => format(d, FMT_PARAM_DATETIME);

/**
 * 日期格式化, 不含时间部分
 * @param d
 * @returns {string | *}
 */
export const formatDate = (d) => format(d, FMT_DATE, defaultOptions);

/**
 * 时间格式化, 不含日期部分
 * @param d
 * @returns {string | *}
 */
export const formatTime = (d) => format(d, FMT_TIME, defaultOptions);

/**
 * 日期时间格式化
 * @param d
 * @returns {string | *}
 */
export const formatDateTime = (d) => format(d, FMT_DATETIME, defaultOptions);
